import React from 'react';

/**
 * Generic Yes/No question with a conditional text field.
 * Value contract: `null` = "No"; any string (even empty) = "Yes" with the informed text.
 */
const RadioGroupConditional = ({ name, label, value, onChange, error, placeholder = 'Descreva', required }) => {
    const isYes = value !== null && value !== undefined;
    const id = `psp-${name}`;

    return (
        <div className="psp-radio-group" role="radiogroup" aria-label={label}>
            <div className="psp-radio-group__options">
                <label className="psp-radio">
                    <input type="radio" name={`${name}-answer`} checked={isYes} onChange={() => onChange(name, value ?? '')} />
                    Sim
                </label>
                <label className="psp-radio">
                    <input type="radio" name={`${name}-answer`} checked={!isYes} onChange={() => onChange(name, null)} />
                    Não
                </label>
            </div>
            {isYes && (
                <div className="psp-field">
                    <input
                        id={id}
                        type="text"
                        className={`psp-input${error ? ' psp-input--invalid' : ''}`}
                        placeholder={placeholder}
                        value={value}
                        onChange={(event) => onChange(name, event.target.value)}
                        aria-label={label}
                        aria-invalid={!!error}
                        required={required}
                    />
                </div>
            )}
            {error && (
                <span className="psp-field__error" role="alert">
                    {error}
                </span>
            )}
        </div>
    );
};

export default RadioGroupConditional;
